import React, { useEffect, useState } from 'react';
import { DataTableSkeleton } from '../../../data/columns';
import dayjs from 'dayjs';
import dashboardApi from '../../../services/dashboardApi';
import { setStartAndEndDate } from '../../../utils/setStartAndEndDate';
import NoData2 from '../../../assets/no-data-2.svg';
import {
  PageHeader,
  TWSelect,
  TWDataTable,
  EmptyState,
} from '../../../components/ui';
import { buildCompanySalesColumns } from './columns';

const CompanySales = () => {
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 20,
    totalRecords: 0,
  });
  const [loading, setLoading] = useState({ listLoading: true });
  const [filter, setFilter] = useState({ isactive: true });
  const [companySales, setCompanySales] = useState({ counts: [] });

  const getCompanySales = async () => {
    try {
      setLoading((prev) => ({ ...prev, listLoading: true }));
      const body = {
        startdate: setStartAndEndDate(dayjs(0), 'startdate', '0'),
        enddate: setStartAndEndDate(dayjs(), 'enddate', '0'),
      };
      const res = await dashboardApi.getReports(body);
      const counts = (res.data.counts || []).filter(
        (item) => item.isactive !== null && item.isactive === filter.isactive,
      );
      setCompanySales({ ...res.data, counts });
      setPagination((prev) => ({ ...prev, totalRecords: counts.length }));
    } catch (error) {
      // silent
    } finally {
      setLoading((prev) => ({ ...prev, listLoading: false }));
    }
  };

  useEffect(() => {
    getCompanySales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const sortedData = companySales.counts || [];
  const paged = sortedData.slice(
    (pagination.pageNumber - 1) * pagination.pageSize,
    pagination.pageNumber * pagination.pageSize,
  );

  const headerActions = (
    <div className="w-full sm:w-52">
      <TWSelect
        placeholder="Status"
        defaultValue={filter.isactive}
        onChange={(value) =>
          setFilter((prev) => ({ ...prev, isactive: value }))
        }
        options={[
          { value: true, label: 'Active' },
          { value: false, label: 'Passive' },
        ]}
      />
    </div>
  );

  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-white dark:bg-slate-800">
      <div className="mx-auto max-w-5xl space-y-8">
        <PageHeader
          title="Company Sales"
          description="View and manage all company sales in one place."
          actions={headerActions}
        />

        {loading.listLoading ? (
          <DataTableSkeleton
            rows={8}
            headers={[
              { label: 'Company', w: 'w-40', shape: 'avatar' },
              { label: 'Live Time Sales', w: 'w-24' },
              { label: 'Live Time Orders', w: 'w-16' },
              { label: 'Avg Tips', w: 'w-16' },
              { label: 'Profit', w: 'w-20' },
              { label: 'Start Date', w: 'w-24' },
            ]}
          />
        ) : sortedData.length === 0 ? (
          <EmptyState image={NoData2} title="No Company Sales" />
        ) : (
          <section className="reveal">
            <TWDataTable
              columns={buildCompanySalesColumns()}
              data={paged}
              rowKey={(record) => record.companyid || record.companyname}
              pagination={{
                showSizeChanger: true,
                current: pagination.pageNumber,
                pageSize: pagination.pageSize,
                total: pagination.totalRecords,
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} results`,
                onChange: (page, pageSize) =>
                  setPagination((prev) => ({
                    ...prev,
                    pageNumber: page,
                    pageSize,
                  })),
              }}
            />
          </section>
        )}
      </div>
    </div>
  );
};

export default CompanySales;
